import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { CustomError } from "@modelos/errors/errors";
import { AuthenticationService } from "@servicios/authentication.service";
import { errorService } from "@servicios/errorService.service";
import { GlobalService } from "@servicios/_helpers/global.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private errorService: errorService,
    private router: Router,
    private gs: GlobalService,
    private auth : AuthenticationService,
    private zone: NgZone) { }

  handleError(error: Error | HttpErrorResponse) {

    if (error instanceof HttpErrorResponse) {
      if (error.status == 455) {
        this.errorService.openDialogError(error.error);
        this.router.navigate(['/backupPage'])
        this.gs.cancelOngoingRequests()
      } else {
        this.errorService.openDialogError(error)
      }
      console.log("Error from server-side", error);
      return
    }

    if(error instanceof CustomError){
      if(error.code == "CE-1000") this.auth.logout()
      this.errorService.openDialogError(error)
      console.log(error)
      return
    }

    this.zone.run(() =>{
      if(error.message.startsWith('NG0100') || error.message.includes('too much recursion') || error.message.includes('Maximum call stack size exceeded')) return
      this.errorService.openDialogError(
        error || { name: 'Error desconocido', message: "Ha ocurrido un error no identificado en el lado del Cliente", stack: error.stack ? error.stack : null }
      )});

    console.error("Error from client-side", error);
  }
}
